<h1 mat-dialog-title>Exceeded File Size limit</h1>
<div style="display:inline-block" mat-dialog-content>
    The combined file size of the attached documents and selected files: '{{data.files}}' has exceeded the maximum 24MB size limit.<br>
    The selected files have been ignored to continue with the document addition process.
</div>
<div mat-dialog-actions>
  <button mat-raised-button mat-dialog-close>Close</button>
</div>
